import { render, staticRenderFns } from "./OrderEvidence.vue?vue&type=template&id=5716ccdd&"
import script from "./OrderEvidence.vue?vue&type=script&lang=js&"
export * from "./OrderEvidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports